/* eslint-disable react/prop-types */
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
// mui
import SearchIcon from '@mui/icons-material/Search';

const MainSearchSection = ({ searchParams, setSearchParams }) => {
  const { t } = useTranslation('global');

  const [inputValue, setInputValue] = useState(searchParams?.keyword ||'');

  const debouncedHandleChange = debounce(value => {
    setSearchParams(prev => ({
      ...prev,
      keyword: value,
    }));
  }, 500);

  const handleChange = useCallback(e => {
    const { value } = e.target;

    setInputValue(value);
    debouncedHandleChange(value);
  }, []); // eslint-disable-line

  return (
    <section className='mainSearchSection'>
      <div className='container'>
        <form onSubmit={e => e.preventDefault()}>
          <div className='mainSearchBox'>
            <SearchIcon sx={{ color: '#797979', width: { xs: 24, sm: 32 }, height: { xs: 24, sm: 32 } }} />
            <input
              type='text'
              name='keyword'
              value={inputValue}
              onChange={e => handleChange(e)}
              placeholder={t('jobseekerListing.searchPlaceholder')}
            />
          </div>
        </form>
      </div>
    </section>
  );
};

export default MainSearchSection;
